<template>
  <div>
    <Spinner v-if="isLoading" />

    <div class="notification is-danger" v-if="loadError">{{ loadError }}</div>

    <div class="table-container" v-if="mapTilesInfo">
      <table class="table is-narrow user-details">
        <tbody>
          <tr>
            <th class="is-narrow">
              <span class="is-pulled-right">Map Tiles Count</span>
            </th>
            <td>
              <span
                >{{ mapTilesInfo.mapTilesTotalCount }} ({{
                  mapTilesInfo.mapTilesUniqueCount
                }}
                unique)</span
              >
            </td>

            <th class="is-narrow">
              <span class="is-pulled-right">Map Tiles Balance</span>
            </th>
            <td>
              <span>{{ mapTilesInfo.mapTilesBalance }}</span>
            </td>
          </tr>
          <tr>
            <th class="is-narrow">
              <span class="is-pulled-right">Subscription Map Tiles Count</span>
            </th>
            <td>
              <span
                >{{ mapTilesInfo.subscriptionMapTilesTotalCount }} ({{
                  mapTilesInfo.subscriptionMapTilesUniqueCount
                }}
                unique)</span
              >
            </td>

            <th class="is-narrow">
              <span class="is-pulled-right"
                >Subscription Map Tiles Balance</span
              >
            </th>
            <td>
              <span>{{ mapTilesInfo.subscriptionMapTilesBalance }}</span>
            </td>
          </tr>
        </tbody>
      </table>

      <button
        class="button is-primary"
        v-if="!isLoading"
        @click="transferMapTiles"
      >
        Transfer Map Tiles to New Owner
      </button>

      <!-- Modals -->
      <UserTransferMapTilesModal
        v-if="showTransferMapTilesModal"
        :userStorePath="userStorePath"
        @cancelled="closeTransferMapTilesModal"
        @succeeded="closeTransferMapTilesModal"
      />
    </div>
  </div>
</template>

<script>
import Spinner from "@/components/utils/Spinner";
import UserTransferMapTilesModal from './UserTransferMapTilesModal'

import {
  LOAD_MAP_TILES_INFO,
  IS_LOADING_MAP_TILES_INFO,
  GET_MAP_TILES_INFO,
  GET_MAP_TILES_INFO_LOAD_ERROR,
} from "./userStore";

export default {
  name: "UserMapTilesTab",

  components: { Spinner, UserTransferMapTilesModal },

  props: {
    userStorePath: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      showTransferMapTilesModal: false
    }
  },

  mounted() {
    const loadMapTilesInfoAction = `${this.userStorePath}/${LOAD_MAP_TILES_INFO}`;
    this.$store.dispatch(loadMapTilesInfoAction);
  },

  methods: {
    transferMapTiles() {
      this.showTransferMapTilesModal = true
    },

    closeTransferMapTilesModal() {
      this.showTransferMapTilesModal = false
    }
  },

  computed: {
    isLoading() {
      const isLoading = `${this.userStorePath}/${IS_LOADING_MAP_TILES_INFO}`;
      return this.$store.getters[isLoading];
    },

    mapTilesInfo() {
      const getMapTilesInfo = `${this.userStorePath}/${GET_MAP_TILES_INFO}`;
      return this.$store.getters[getMapTilesInfo];
    },

    loadError() {
      const getMapTilesInfoLoadError = `${this.userStorePath}/${GET_MAP_TILES_INFO_LOAD_ERROR}`;
      return this.$store.getters[getMapTilesInfoLoadError];
    }
  },

  watch: {
    mapTilesInfo() {
      // Make sure all modals are closed when the map tiles info changes.
      // This may happen, for example, when the map tiles info is reloaded after map tiles have been transfered.
      this.showTransferMapTilesModal = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.table {
  th {
    padding-right: 0 !important;
    border-bottom: 0;

    span {
      font-weight: normal;
    }
  }

  td {
    border-bottom: 0;

    span {
      font-weight: bold;
      white-space: nowrap;
    }
  }
}
</style>
